import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';

// COMPONENTS
import AgendamentoMedicoRenachIntegrado from 'pages/DetranCnh/components/pages/AgendamentoMedicoRenachIntegrado';
import ButtonImage from 'components/Common/ButtonImage';

// ROUTES
import { useHistory } from 'react-router-dom';
import { ROUTE_DETRAN_CNH_PRIMEIRA_HABILITACAO_AGENDAMENTO_PSICOLOGICO } from 'pages/DetranCnh/routes/paths';

// REDUX
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';

// FORM
import { initialValues, dadosCidadao } from './form';

const AgendamentoMedicoPrimeiraHabilitacao: React.FC = () => {
	const history = useHistory();
	const [isLoading, setIsLoading] = useState(true);

	const { saveGerarRenach } = useSelector(
		(state: ApplicationState) => state.api.detranCnh.sockets,
	);

	const consultaCategoria = useSelector(
		(state: ApplicationState) => state.api.detranCnh.consulta.consultaCategoria,
	);

	useEffect(() => {
		if (saveGerarRenach.data?.gerarRenachBase) {
			const {
				cpf,
				logradouroCep,
				codCiretranHabilitacao,
				categoriaPretendida,
			} = saveGerarRenach.data?.gerarRenachBase;

			initialValues.categoria_pretendida =
				consultaCategoria.divisaoEquitativa.filter(
					divisaoEquitativa => divisaoEquitativa.codigo === categoriaPretendida,
				)[0].codigoDivisaoEquitativa;
			initialValues.cpf_cidadao = Number(cpf);
			initialValues.cep_cidadao = Number(logradouroCep);
			initialValues.codigo_ciretran_exame_medico = Number(
				codCiretranHabilitacao,
			);
		}
	}, [consultaCategoria.divisaoEquitativa, saveGerarRenach.data]);

	useEffect(() => {
		if (saveGerarRenach.data?.gerarRenachBase) {
			const {
				cpf,
				nome,
				nomeSocial,
				nomePai,
				nomeMae,
				numDocumento,
				dataNascimento,
				sexo,
				nacionalidade,
				naturalidade,
				categoriaPretendida,
				logradouroCep,
				rneNumero,
				flagDeficienteFisico,
			} = saveGerarRenach.data?.gerarRenachBase;

			// DADOS CIDADÃO
			dadosCidadao.nome = nomeSocial || nome;
			dadosCidadao.nomeMae = nomeMae;
			dadosCidadao.nomePai = nomePai;
			dadosCidadao.numeroRg = numDocumento;
			dadosCidadao.rne = rneNumero || '';
			dadosCidadao.cpf = cpf;
			dadosCidadao.sexo = sexo;
			dadosCidadao.nacionalidade = nacionalidade;
			dadosCidadao.cep = logradouroCep;
			dadosCidadao.dataNascimento = dataNascimento;
			dadosCidadao.naturalidade = naturalidade || '';
			dadosCidadao.categoriaPretendida =
				consultaCategoria.divisaoEquitativa?.filter(
					divisaoEquitativa => divisaoEquitativa.codigo === categoriaPretendida,
				)[0]?.codigoDivisaoEquitativa || categoriaPretendida;
			dadosCidadao.isPortadorNecessidadesEspeciais =
				!!flagDeficienteFisico || flagDeficienteFisico === 'S';

			setIsLoading(false);
		}
	}, [consultaCategoria.divisaoEquitativa, saveGerarRenach.data]);

	return (
		<>
			{!isLoading && (
				<>
					<AgendamentoMedicoRenachIntegrado
						dadosAgendamento={initialValues}
						dadosCidadao={dadosCidadao}
						redirecionamento={
							ROUTE_DETRAN_CNH_PRIMEIRA_HABILITACAO_AGENDAMENTO_PSICOLOGICO
						}
					/>
					<Row justify="space-between" align="middle">
						<Col>
							{/* MANTER OCULTO ATÉ ALINHAMENTO COM O 2.0 PARA APLICAR O MESMO FLUXO EM AMBOS (VOLTAR PARA A TELA ANTERIOR).
								<ButtonVoltar
									navigate={false}
									onClick={() => history.push('/detran-cnh')}
								/> 
							*/}
						</Col>
						<Col>
							<ButtonImage
								type="button"
								src="outro-servico-detran"
								onClick={() => history.push('/detran-cnh')}
							/>
						</Col>
					</Row>
				</>
			)}
		</>
	);
};
export default AgendamentoMedicoPrimeiraHabilitacao;
